import React, {Component} from 'react'
import { submit, isSubmitting } from 'redux-form'
import { connect } from 'react-redux'
import {
  TextInput,
  fetchEnd,
  fetchStart,
  required,
  showNotification,
  SimpleForm,
  SaveButton
} from 'react-admin'
import { Redirect } from 'react-router'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Slide from '@material-ui/core/Slide'

import axiosClient from '../../../config/axios'
import { toggleRegisterUserModal } from '../../../redux/actions/modals'
import CancelButton from '../../../components/CancelButton'

const FORM_NAME = 'register-user'

function Transition (props) {
  return <Slide direction='up' {...props} />
}

class RegisterUserModal extends Component {
  constructor (props) {
    super(props)

    this.state = {}

    this._submit = this._submit.bind(this)
  }

  async _submit (values) {
    const { fetchStart, fetchEnd, showNotification } = this.props
    try {
      // Dispatch an action letting react-admin know a API call is ongoing
      fetchStart()

      const res = await axiosClient()
        .post(`/register`, {
          username: values.username,
          password: values.password
        })

      this.props.toggleRegisterUserModal()
      showNotification('New user registered successfully', 'info')
      fetchEnd()
      this.setState({
        redirectTo: `/user/${res.data.user._id}`
      })
    } catch (err) {
      showNotification(err.message, 'error')
      fetchEnd()
    } finally {
      fetchEnd()
    }
  }

  render () {
    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} />
    }

    return (
      <Dialog
        fullScreen={window.innerWidth < 600}
        open={this.props.isOpen}
        onClose={this.props.toggleRegisterUserModal}
        TransitionComponent={window.innerWidth < 600 ? Transition : undefined}
      >
        <DialogTitle>Edit password</DialogTitle>
        <DialogContent>
          <SimpleForm
            form={FORM_NAME}
            onSubmit={this._submit}
            toolbar={null}
            validate={validate}
          >
            <TextInput
              source='username'
              validate={required()}
              resettable
            />
            <TextInput
              source='password'
              type='password'
              validate={required()}
              resettable
            />
            <TextInput
              source='repeatPassword'
              type='password'
              validate={required()}
              resettable
            />
          </SimpleForm>
        </DialogContent>
        <DialogActions>
          <CancelButton
            onClick={this.props.toggleRegisterUserModal}
          />
          <SaveButton
            saving={this.props.isSubmitting}
            onClick={() => this.props.submit(FORM_NAME)}
          />
        </DialogActions>
      </Dialog>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (values.password && values.password.length < 8) {
    errors.password = 'Passwords is too short'
  }
  if (values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Passwords do not match'
  }
  return errors
}

const mapStateToProps = (state) => ({
  ...state.modals.registerUser,
  isSubmitting: isSubmitting(FORM_NAME)(state)
})

export default connect(mapStateToProps, {
  toggleRegisterUserModal,
  fetchEnd,
  fetchStart,
  showNotification,
  submit
})(RegisterUserModal)
